<template>
  <Layout class="layout--basic">
    <HeaderRoot :title="mobileTitle ? mobileTitle : title">
      <slot name="header"></slot>
    </HeaderRoot>
    <div class="layout__wrapper">
      <PageTitle :title="title" />
      <slot></slot>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import Layout from '@/app/components/Layout.vue'
import PageTitle from '@/app/components/header/PageTitle.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

/**
 * A basic layout with a header.
 *
 * It's the default layout for root level pages, such as the Discover and My Library pages.
 *
 * @param title - The title of the page. It's used in the desktop header and, if no `mobileTitle` is provided, in the mobile header too.
 * @param mobileTitle - A shorter title to be displayed in the mobile header.
 */

defineProps<{
  title: string
  mobileTitle?: string
}>()
</script>
